/* eslint-disable no-multi-str */
import "../Landing/Landing.scss";

import Nav from "../Nav/Nav";
import HeroTest from "./HeroTest";
import HowItWorks from "../HowItWorks/HowItWorks";
import FAQ from "../FAQ/FAQ";
import Footer from "../Footer/Footer";
import ExitIntent from "../ExitIntent/ExitIntent";

import altice from "../../assets/altice.svg";
import century from "../../assets/century.svg";
import coxbusiness from "../../assets/coxbusiness.svg";

import graymotif from "../../assets/graymotif.svg";
import whitemotif from "../../assets/whitemotif.svg";

import globe from "../../assets/globe.svg";
import coverage from "../../assets/coverage.svg";
import prices from "../../assets/prices.svg";
import support from "../../assets/support.svg";
import bandwidth from "../../assets/bandwidth.svg";
import installation from "../../assets/installation.svg";
import darkarrow from "../../assets/dark-arrow.svg";

import React from "react";
import { Link } from "react-router-dom";
import { Mixpanel } from "../../helpers/mixpanel";

function LandingTest() {
  React.useEffect(() => {
    Mixpanel.track("LANDED ON THE HOME PAGE - TEST");
  }, []);

  return (
    <div>
      <ExitIntent />


      <div className="relative">
        <Nav />
        <HeroTest />

        <div className="relative">
          <div className="px-5 sm:px-20 py-24 pb-36 sm:py-32 xl:py-52">
            <h3 className="text-center font-bold sm:w-6/12 xl:w-4/12 mx-auto text-xl sm:text-2xl xl:text-3xl">
              Interconnected with over 100 carriers nationwide
            </h3>
            <div className="clients sm:w-7/12 mx-auto flex justify-between mt-8 lg:mt-16">
              <img src={coxbusiness} alt="cox" />
              <img src={altice} alt="altice" />
              <img src={century} alt="century" />
            </div>
          </div>
          <div className="absolute bottom-0 -mb-32 flex w-full justify-center">
            <img src={graymotif} alt="motif" className="" />
          </div>
        </div>

        <HowItWorks />

        <div className="relative">
          <div className="px-5 sm:px-28 xl:px-60 py-24 pb-36 sm:py-32 xl:py-24 xl:pb-44 bg-blue">
            <h3 className="text-center font-bold mx-auto text-xl sm:text-2xl xl:text-3xl text-white">
              Why Fiberfed?
            </h3>
            <div className="features">
              <div className="feature">
                <img src={globe} alt="globe" />
                <div>
                  <h2>Reliable</h2>
                  <p>
                    We have 100% uptime across all fiber services through the
                    country
                  </p>
                </div>
              </div>
              <div className="feature">
                <img src={coverage} alt="coverage" />
                <div>
                  <h2>Wide Coverage</h2>
                  <p>
                    Strategic partnerships with many networks enables us to
                    provide coverage anywhere
                  </p>
                </div>
              </div>
              <div className="feature">
                <img src={prices} alt="prices" />
                <div>
                  <h2>Affordable Prices</h2>
                  <p>Our prices are the most competitive across the country</p>
                </div>
              </div>
              <div className="feature">
                <img src={support} alt="support" />
                <div>
                  <h2>24/7 Customer Support</h2>
                  <p>
                    Always on call to answer your questions and provide support
                  </p>
                </div>
              </div>
              <div className="feature">
                <img src={bandwidth} alt="bandwidth" />
                <div>
                  <h2>High Bandwidth</h2>
                  <p>
                    Up to 10,000MbS upload/download with ultra low latency and
                    jitter.
                  </p>
                </div>
              </div>
              <div className="feature">
                <img src={installation} alt="installation" />
                <div>
                  <h2>Fast Installation</h2>
                  <p>We install fiber in less than 30 days</p>
                </div>
              </div>
            </div>

            <div className="mt-10 flex justify-center">
              <Link to="/app/pick-mechanism">
                <button
                  className="cta cta-hover uppercase bg-orange border-orange text-dark"
                  onClick={() => Mixpanel.track("CLICKED GET QUOTE")}
                >
                  get free quote <img alt="arrow" src={darkarrow} />
                </button>
              </Link>
            </div>
          </div>
          <div className="absolute bottom-0 -mb-32 flex w-full justify-center">
            <img src={whitemotif} alt="motif" className="" />
          </div>
        </div>

        <div className="relative bg-gray">
          <div className="absolute top-0 -mt-32 flex w-full justify-center">
            <img src={whitemotif} alt="motif" className="" />
          </div>
          <div className="py-32 xl:py-56 w-10/12 lg:w-8/12 xl:w-7/12 mx-auto">
            <h3 className="text-center font-bold text-3xl sm:text-5xl xl:text-6xl">
              FAQs
            </h3>
            <div className="mt-12">
              {faq.map((value, index) => {
                return <FAQ key={index} faq={value} />;
              })}
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
}

export default LandingTest;

const faq = [
  {
    title: "How do I get my $25 Amazon credit?",
    content:
      "Simply complete a quote request with a valid business address. Once we verify your submission, \
      we'll email your $25 Amazon credit within 24 hours. No purchase required!",
  },
  {
    title: "How does the 1st Month FREE offer work?",
    content:
      "If you sign up for service within 30 days you receive your quote, your first month of service is completely free. \
      This offer is automatically applied - just mention you'd like to proceed when our team reaches out!",
  },
  {
    title: "ATT and Verizon I have heard of, Who is FiberFed?",
    content:
      "FiberFed is a Competitive alternative to Local Telephone and Cable Companys. We leverage the best part of those companies \
      and provide better pricing and better customer service. We have Wholesale contracts with almost every Fiber Network in the US. \
      We leverage our technology to find the best network, at the best price, with the quickest install.",
  },
  {
    title: "Why FiberFed?",
    content:
      "FiberFed uses its proprietary database algorithms for cost savings and order efficiencies. Since we have our nationwide \
      Fiber network to leverage, we are able to get the best and quickest communications solutions that can be found in the \
      Telecom market today. Try us and if you don't agree, you can cancel your order!",
  },
  {
    title: "How does the Fiber Finder work?",
    content:
      "Enter your address, pick your speed, and get instant pricing. It takes less than 60 seconds. \
      We check availability across 100+ carriers and give you the best options immediately.",
  },
  {
    title: "What Services can I buy through FiberFed?",
    content:
      "We specialize in Fiber! Dedicated Internet, MPLS, Wave services, SDWAN, and Direct Cloud connections. \
      Broadband is also available. If there is electricity, there is a good chance we can provide service.",
  },
  {
    title: "Do you sell my info?",
    content:
      "No. You are our client, and we are your trusted advisor. Your info is safe with us.",
  },
  {
    title: "What if I order, and then want to cancel?",
    content:
      "We allow canceling with no charge for 5 business days after order. After we establish a firm install date, some fees may apply.",
  },
];
